// Deprecated unused.
import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { SectionBlock } from "../../../components/light/SectionBlock";
import { Loading } from "../../../components/Loading";
import {
  Stepper,
  Step,
  StepLabel,
  makeStyles,
  withStyles,
  StepConnector,
  StepIconProps,
} from "@material-ui/core";
import clsx from "clsx";
import { CheckCircle } from "@material-ui/icons";
//@ts-ignore
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";
import styles from "./disburement.module.scss";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "disbursement", to: "#" },
  { text: "disbursement log", to: "/applications/disbursement/log" },
];

const Disbursement_List = gql`
  query disbursementLog($offset: Int = 0, $limit: Int = 10) {
    disbursementLog(offset: $offset, limit: $limit)
  }
`;

export function DisbursementLogScreen() {
  const query = new URLSearchParams(window.location.search);
  const { replace } = useHistory();
  const { data, loading } = useQuery(Disbursement_List, {
    fetchPolicy: "no-cache",
    variables: {
      offset: 0,
      limit: 100000,
    },
  });

  useEffect(() => {
    if (query.get("filter") === null) {
      replace({
        pathname: "/applications/disbursement/log",
        search: "?filter=PROCESSING",
      });
    }
  }, [query, replace]);

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock title="Disbursement Log">
          <Loading />
        </SectionBlock>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-8">
          <SectionBlock title="Disbursement Log" transparent={true}>
            <DisbursementList items={data.disbursementLog} />
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}

function DisbursementList({ items }: { items: any[] }) {
  const [, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  return (
    <table className="table table-striped">
      <tbody>
        {items.map((x, i) => {
          return (
            <tr key={i}>
              <td>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {x.proof &&
                    (String(x.proof).split(".")[
                      String(x.proof).split(".").length - 1
                    ] === "pdf" ? (
                      <a href={"http:" + x.proof} target="_blank" rel="noopener noreferrer">
                        <Document
                          file={"http:" + x.proof}
                          onLoadSuccess={onDocumentLoadSuccess}
                          className={styles.pdf}
                          renderMode="svg"
                        >
                          <Page pageNumber={pageNumber} width={75} />
                        </Document>
                      </a>
                    ) : (
                      <img
                        src={"https:" + x.proof}
                        alt=""
                        style={{
                          width: 50,
                          boxShadow: "0px 0px 3px 0px rgba(0,0,0,0.75)",
                          marginRight: 10,
                        }}
                      />
                    ))}
                  <div>
                    <Link
                      to={
                        "/applications/disbursement/detail/" + x.disburse_uuid
                      }
                    >
                      <span>{x.disburse_uuid}</span>
                    </Link>
                    <br />
                    <small className="text-success">
                      Amount: {x.amount} USD
                    </small>
                    <br />
                    <small>Request Date: {x.log[0].date}</small>
                  </div>
                </div>
              </td>
              <td>
                <Stepper
                  style={{
                    backgroundColor: 'transparent'
                  }}
                  alternativeLabel
                  activeStep={x.log.filter((y: any) => y.date !== null).length}
                  connector={<QontoConnector />}
                >
                  {x.log.map((y: any) => {
                    return (
                      <Step key={y.status}>
                        <StepLabel StepIconComponent={QontoStepIcon}>
                          <span>{y.status}</span>
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "#24b314",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#24b314",
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#24b314",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: "#24b314",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props: StepIconProps) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckCircle className={classes.completed} />
      ) : (
        <div className={classes.circle} defaultChecked={false} />
      )}
    </div>
  );
}
